import React from 'react';
import { NavLink, Routes, Route, Navigate } from 'react-router-dom';
import BidDetailPage from './BidDetailPage';
import DocumentsPage from './DocumentsPage';
import InlineEditorPage from './InlineEditorPage';
import DrawingDetailPage from './DrawingDetailPage';

export default function BidDetailLayout() {
  return (
    <div className="container mx-auto py-6">
      <nav className="mb-4 border-b">
        <ul className="flex space-x-4">
          <li>
            <NavLink
              to=""
              end
              className={({ isActive }) =>
                isActive ? 'text-blue-600 border-b-2 border-blue-600 pb-1' : 'text-gray-600 pb-1'
              }
            >
              Info
            </NavLink>
          </li>
          <li>
            <NavLink
              to="documents"
              className={({ isActive }) =>
                isActive ? 'text-blue-600 border-b-2 border-blue-600 pb-1' : 'text-gray-600 pb-1'
              }
            >
              Drawings
            </NavLink>
          </li>
        </ul>
      </nav>
      <div>
        <Routes>
          <Route index element={<BidDetailPage />} />
          <Route path="documents" element={<DocumentsPage />} />
          <Route path="edit" element={<InlineEditorPage />} />
          <Route path="drawings/:pageId" element={<DrawingDetailPage />} />
          <Route path="*" element={<Navigate to="documents" replace />} />
        </Routes>
      </div>
    </div>
  );
}